import React from 'react'
import { useQuery } from '@apollo/client';
import { ErrorComponent, GallerySkeleton } from '../../components';
import { GALLERY_IMAGES } from '../../utils/constants/queries';
import GalleryImage from '../../components/GalleryImage/galleryImage';

export default function Gallery() {
    const { loading, error, data } = useQuery(GALLERY_IMAGES);  
    const gallerImages =  (loading)?  <GallerySkeleton/>:
    
    error?<ErrorComponent message={error.message}/>:data.gallery.map((image)=><GalleryImage image={image.image} id ={image.id} key = {image.id}/>);

    return (
        <div className="gallery-area pt-180 pb-70">
        <div className="section-title">
            <h2>Gallery</h2>
            <p>
            Here is a walk down a digital path of Child Hope and it’s day to day activities. 
            </p>
        </div>
        <div className="container-fluid">
            <div className="row">
                {gallerImages}
            </div>
        </div>
    </div>
    )
}
